import request from '@/plugins/request'

const API = {
  list: '/student/pc/practiceAssessment/list',
  uploadReport: '/student/pc/practiceAssessment/uploadReport'
}

export function getPracticeAssessmentList() {
  return request.get(API.list)
}

export function uploadPracticeReport(data) {
  return request.post(API.uploadReport, data)
}
